//// Imports /////
//////////////////

import { OverlayScrollbars } from "overlayscrollbars";

///// Utils. /////
//////////////////

export function trackScrollPos(el, scrollbarInst) {
  const { overflowAmount } = scrollbarInst.state();
  const { viewport } = scrollbarInst.elements();
  const { scrollTop } = viewport;

  // Near-top updt. //
  el.dataset.nearTop = scrollTop < 100 && overflowAmount.y > 0 ? "true" : "false";

  // Near-bottom updt. //
  const totalScrollHeight = viewport.scrollHeight;
  const viewportHeight = window.innerHeight;
  el.dataset.nearBottom = scrollTop + viewportHeight > totalScrollHeight - 100 && overflowAmount.y > 0 ? "true" : "false";
}

////// fn() //////
//////////////////

export default function init_pageScrollbar() {
  // Scrollbar inst. init. //
  const el_body = document.body;
  const inst_os = OverlayScrollbars(
    document.body,
    {
      scrollbars: { theme: "os-theme-cef" },
      overflow: { x: "hidden", y: "scroll" },
    },
    {
      scroll(inst) {
        trackScrollPos(el_body, inst);
      },
    }
  );

  // Scrollbar inst. storing //
  inst_os._originalOverflow = { x: "hidden", y: "scroll" }; // Store original overflow settings
  window.osInst = inst_os;

  return inst_os;
}

// Helper functions for controlling scroll
export function lockScroll() {
  if (window.osInst) {
    window.osInst.options({ overflow: { x: "hidden", y: "hidden" } });
  }
}

export function unlockScroll() {
  if (window.osInst && window.osInst._originalOverflow) {
    window.osInst.options({ overflow: window.osInst._originalOverflow });
  }
}
